"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Footer = _interopRequireDefault(require("../Footer/Footer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FooterHandler = _ref => {
  let {
    data,
    Link
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Footer.default, {
    calloutLinks: data.calloutLinks,
    sectorFooterLinks: data.sectorFooterLinks,
    socialLinksTitle: data.socialLinksTitle,
    socialLinks: data.socialLinks,
    logo: data.logo,
    globalFooterText: data.globalFooterText,
    globalFooterEnabled: data.globaFooterEnabled,
    legalStuff: data.legalStuff,
    Link: Link,
    contentfulId: data?.contentfulId
  });
};
var _default = FooterHandler;
exports.default = _default;